export default {
    inserted: function (el, binding, vnode) {
        if (vnode.elm.innerText.length === 0) {
            vnode.elm.innerHTML = '—'
            vnode.elm.classList.add('text-muted')
        }
    }
}
